var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAuction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46214 0L11.5392 5.07675L10.6162 6.00098L9.92428 5.76992L8.30744 7.38472L12 11.0771L11.077 12L7.38512 8.30764L5.81593 9.87675L6.00065 10.6156L5.07702 11.5385L0 6.46179L0.923629 5.53886L1.66123 5.72293L5.76958 1.61545L5.53917 0.923579L6.46214 0Z",
    fill: "#FCD559"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAuction);
export default __webpack_public_path__ + "static/media/icon-auction.fb209f456c99a57865ae28e2d2f9280c.svg";
export { ForwardRef as ReactComponent };